import React from "react";


const Infoip = ({infoIp}) => {
  return (
    <section className="info">
      <div>
        <h4>IP address</h4>
        <p>{infoIp && infoIp.ip}</p>
      </div>
      <div>
        <h4>Location</h4>
        <p className="loca">
        {infoIp && infoIp.location.city}{" "}
        {infoIp && infoIp.location.region}{" , "}
        {infoIp && infoIp.location.country}
        </p>
      </div>
      <div>
        <h4>timezone</h4>
        <p>{infoIp && infoIp.location.timezone}</p>
      </div>
      <div className="last">
        <h4>isp</h4>
        <p>{infoIp && infoIp.isp}</p>
      </div>
    </section>
  );
};

export default Infoip;
